export default function BackButton({ onClick, game }) {
  return (
    <button
      className={`back-icon-btn${game ? ' back-icon-btn--game' : ''}`}
      onClick={onClick}
      aria-label="वापस"
    >
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <polygon points="12,7 5.5,12 12,17" fill="#F5D76E" />
        <rect x="5.5" y="10.8" width="10.5" height="2.4" rx="1.2" fill="#F5D76E" />
        <path
          d="M16 7.5C18.5 7.5 20 9.5 20 12C20 14.5 18.5 16.5 16 16.5"
          stroke="#F5D76E"
          strokeWidth="2.5"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    </button>
  );
}
